// Traduzione dell'interfaccia: l'app è scritta in italiano; per le altre lingue
// un dizionario (generato) sostituisce i testi dell'interfaccia direttamente nel DOM.
const LOCALE_TAG = { it: "it-IT", en: "en-GB", es: "es-ES", de: "de-DE", sq: "sq-AL", ro: "ro-RO" };

export const LANGS = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "de", label: "Deutsch" },
  { code: "sq", label: "Shqip" },
  { code: "ro", label: "Română" },
];

export const getLang = () => {
  const l = localStorage.getItem("lang");
  return LOCALE_TAG[l] ? l : "it";
};
export const localeTag = () => LOCALE_TAG[getLang()];
export const fcLocaleCode = () => (getLang() === "en" ? "en-gb" : getLang());

export const applyLang = (code) => {
  if (!LOCALE_TAG[code] || code === getLang()) return false;
  localStorage.setItem("lang", code);
  window.location.reload();
  return true;
};

let dict = null;
const NUM = /\d+(?:[.,:]\d+)*/g;
const SKIP = "[data-no-translate],[translate='no'],script,style,code,pre";
const TEXT_SKIP = `${SKIP},textarea`;
const ATTRS = ["placeholder", "title", "aria-label"];
const textState = new WeakMap();
const attrState = new WeakMap();

const byPattern = (key, re) => {
  const vals = [];
  const tr = dict[key.replace(re, (m) => `{${vals.push(m) - 1}}`)];
  return tr == null ? null : tr.replace(/\{(\d+)\}/g, (_, i) => vals[Number(i)] ?? "");
};

const lookup = (key) => {
  if (dict[key] != null) return dict[key];
  if (!/\d/.test(key)) return null;
  return byPattern(key, NUM) ?? byPattern(key, /\S*\d\S*/g);
};

const translateString = (s) => {
  const key = s.trim();
  if (!key || key.length > 600 || !/[A-Za-zÀ-ÿ]/.test(key)) return null;
  const out = lookup(key);
  return out == null || out === key ? null : s.replace(key, () => out);
};

export const t = (s) => (dict && translateString(s)) || s;

const doText = (n, checked) => {
  const v = n.nodeValue;
  if (textState.get(n) === v) return;
  if (n.parentElement?.closest(checked ? "textarea" : TEXT_SKIP)) return;
  const out = translateString(v);
  if (out != null) {
    textState.set(n, out);
    n.nodeValue = out;
  }
};

const doAttrs = (el) => {
  let st = attrState.get(el);
  for (const a of ATTRS) {
    const v = el.getAttribute(a);
    if (!v || st?.[a] === v) continue;
    const out = translateString(v);
    if (out != null) {
      st = st || {};
      st[a] = out;
      attrState.set(el, st);
      el.setAttribute(a, out);
    }
  }
};

const walk = (root) => {
  if (root.nodeType === 3) return doText(root, false);
  if (root.nodeType !== 1 || root.closest(SKIP)) return;
  doAttrs(root);
  const w = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
    acceptNode: (n) => (n.nodeType === 1 && n.matches(SKIP) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
  });
  for (let n = w.nextNode(); n; n = w.nextNode()) {
    if (n.nodeType === 3) doText(n, true);
    else doAttrs(n);
  }
};

export async function initI18n() {
  const lang = getLang();
  document.documentElement.lang = lang;
  if (lang === "it") return;
  try {
    dict = (await import(`./locales/${lang}.json`)).default;
  } catch {
    return;
  }
  walk(document.body);
  new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "childList") m.addedNodes.forEach(walk);
      else if (m.type === "characterData") doText(m.target, false);
      else if (m.target.nodeType === 1 && !m.target.closest(SKIP)) doAttrs(m.target);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
}
